"use strict";
//
//  OMRealtimeSubscription.ts
//  Firmament
//
//  Created by Cheong Kit Tham on 04/06/2020.
//  Copyright © 2020 Apptivity Lab. All rights reserved.
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const v4_1 = __importDefault(require("uuid/v4"));
const __1 = require("..");
const Command_1 = require("../Command");
const helpers_1 = require("../helpers");
const ObjectModel_1 = require("../ObjectModel");
class OMRealtimeSubscription {
    constructor(subject) {
        this.id = v4_1.default();
        this.subject = subject;
    }
    get query() {
        if (!this._query) {
            const query = this.subject.query();
            this._query = query;
        }
        return this._query;
    }
    // tslint:disable-next-line:max-line-length
    listen(handler) {
        this.handler = handler;
        this.socketEventHandler = (json) => __awaiter(this, void 0, void 0, function* () {
            try {
                const { command: rawCommand } = json;
                if (!rawCommand) {
                    return;
                }
                const commandType = rawCommand.type;
                const obj = yield (() => __awaiter(this, void 0, void 0, function* () {
                    const { result: rawResult } = json;
                    if (!rawResult) {
                        return;
                    }
                    if (rawResult.type !== this.subject.Type) {
                        return;
                    }
                    const objInstance = new this.subject(helpers_1.JsonUtils.transformObject({ data: rawResult })[0]);
                    if (!objInstance) {
                        return;
                    }
                    if (!this._query) {
                        return objInstance;
                    }
                    else {
                        return yield new ObjectModel_1.OMReference(this.subject, objInstance.id).load(this.query);
                    }
                }))();
                const receiver = yield (() => __awaiter(this, void 0, void 0, function* () {
                    const { receiver: rawReceiver } = json;
                    if (!rawReceiver) {
                        return;
                    }
                    if (rawReceiver.type !== this.subject.Type) {
                        return;
                    }
                    const objInstance = new this.subject(helpers_1.JsonUtils.transformObject({ data: rawReceiver })[0]);
                    if (!objInstance) {
                        return;
                    }
                    if (!this._query) {
                        return objInstance;
                    }
                    else {
                        return yield new ObjectModel_1.OMReference(this.subject, objInstance.id).load(this.query);
                    }
                }))();
                const command = (() => {
                    switch (commandType) {
                        case "om_create":
                            return obj && new this.subject.Create(obj);
                        case "om_update":
                            return obj && new this.subject.Update(obj);
                        case "om_delete":
                            // tslint:disable-next-line
                            console.warn("OMDelete is currently not supported.");
                            break;
                        default:
                            class SomeCommand extends Command_1.Command {
                            }
                            SomeCommand.Type = rawCommand && rawCommand.type || Command_1.Command.Type;
                            return receiver && new SomeCommand(receiver);
                    }
                })();
                if (!command) {
                    return;
                }
                if (!handler) {
                    return;
                }
                handler(command);
            }
            catch (error) {
                if (this.errorHandler) {
                    this.errorHandler(error);
                }
            }
        });
        const roomName = this.socketRoomName;
        if (!roomName) {
            return this;
        }
        __1.OMUniverse.shared.realtimeClient.subscribe(roomName, this);
        return this;
    }
    unsubscribe() {
        const handlerId = this.socketHandlerId;
        if (!handlerId) {
            return;
        }
        __1.OMUniverse.shared.realtimeClient.unsubscribe(handlerId);
    }
    include(relationship) {
        this.query.include(relationship);
        return this;
    }
    filter(keyPath, filterOperator, value) {
        this.query.filter(keyPath, filterOperator, value);
        return this;
    }
    filterGroup(filters, joinOperator = "AND") {
        this.query.filterGroup(filters, joinOperator);
        return this;
    }
}
exports.OMRealtimeSubscription = OMRealtimeSubscription;
//# sourceMappingURL=OMRealtimeSubscription.js.map